import styled from 'styled-components';

//game-info-amount game-info-text
export const JackpotAmountPreviewDefaultBox = styled.div`
    font-family: ${props => props.theme.font.family.bold};
    font-size: 2.4rem;
    font-weight: 800;
    color:  ${props => props.theme.colors.brandPrimary};
    text-align: inherit;
    margin-top: -4px;
    margin-bottom: 5px;
    padding: 0 1.5rem;
    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        font-size: 2.2rem;
    }
`;